module.exports = __webpack_public_path__ + "static/media/Taurus.b02f555e.png";